const boxesPrices = [
    {
        id: 1,
        title: "Nettoyage Intérieur",
        price: 35,
        list: [
            "✓ Aspirateur Habitacle",
            "✓ Soufflage Au Pistolet",
            "✓ Shampooing Sièges",
            "❌ Nettoyage Avec Injecteur",
            "✓ Dégraissage Plastique",
            "✓ Brillant Plastique",
            "✓ Nettoyage Vitres"

        ]
    },
    {
        id: 2,
        title: "Nettoyage Exterieur",
        price: 35,
        list: [
            "✓ Prélevage Au Canon",
            "❌ Lavage Gant Microfibe",
            "✓ Shampooing Deperlant",
            "✓ Nettoyage Des Jantes",
            "✓ Nettoyage Des Vitres ",
            "✓ Séchage Micro Fibre",
            "✓ Nettoyage Des Portes"

        ]
    },
    {
        id: 3,
        title: "Nettoyage Complet",
        price: 50,
        list: [
            "✓ Aspirateur Habitacle",
            "✓ Prélevage Au Canon",
            "✓ Lavage Gant Microfibe",
            "✓ Shampooing Deperlant",
            "✓ Nettoyage Des Jantes",
            "✓ Nettoyage Des Vitres ",
            "✓ Séchage Micro Fibre",
            "✓ Nettoyage Des Portes",
            "✓ + Autres Options"

        ]
    },
    {
        id: 4,
        title: "Nettoyage Rapide",
        price: 25,
        list: [
            "✓ Prélevage Au Canon",
            "✓ Lavage Gant Microfibe",
            "✓ Nettoyage Des Jantes",
            "✓ Nettoyage Des Vitres ",
            "✓ Nettoyage Des Portes",
            "❌ Shampooing Deperlant",
            "❌ Séchage Micro Fibre"

        ]
    }
]
export default boxesPrices;








